import React, { useState } from 'react'
import { FAQStyles } from 'styles/style';
import { ReactComponent as PlusIcon } from "feather-icons/dist/icons/plus.svg";
import { ReactComponent as MinusIcon } from "feather-icons/dist/icons/minus.svg";

const QnAContent = ({
    faqs = []
 }) => {
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(null);

  return (
    <FAQStyles.FAQContent>
        <FAQStyles.FAQSContainer>
            {faqs.map((faq, index) => (
                <FAQStyles.FAQContainer
                    onClick={() => {
                        setActiveQuestionIndex(
                            activeQuestionIndex === index ? null : index
                        );
                    }}
                    key={index}
                    className='group'
                >
                    <FAQStyles.Question>
                        <FAQStyles.QuestionText>{faq.question}</FAQStyles.QuestionText>
                        <FAQStyles.QuestionToggleIcon>
                            {activeQuestionIndex === index ? (
                                <MinusIcon />
                            ) : (
                                <PlusIcon />
                            )}
                        </FAQStyles.QuestionToggleIcon>
                    </FAQStyles.Question>
                    <FAQStyles.Answer
						variants={{
							open: {
								opacity: 1,
								height: "auto",
								marginTop: "16px",
								pointerEvents: "auto", // Enable pointer events when open
							},
							collapsed: {
								opacity: 0,
								height: 0,
								marginTop: "0px",
								pointerEvents: "none", // Disable pointer events when collapsed
							},
						}}
						initial="collapsed"
						animate={
							activeQuestionIndex === index
								? "open"
								: "collapsed"
						}
						transition={{
							duration: 0.3,
							ease: [0.04, 0.62, 0.23, 0.98],
						}}
					>
						{faq.answer.trim()}
					</FAQStyles.Answer>
                </FAQStyles.FAQContainer>
            ))}
        </FAQStyles.FAQSContainer>
    </FAQStyles.FAQContent>
  )
}

export default QnAContent